!function () {
    let e = "fr" == Shopify.locale ? "" : `/${Shopify.locale}`;

    class t extends HTMLElement {
        constructor() {
            super(), this.bindEvents = this.bindEvents.bind(this), this.userTyping = this.userTyping.bind(this), this.getCollectionsSuggestions = this.getCollectionsSuggestions.bind(this), this.getArticlesSuggestions = this.getArticlesSuggestions.bind(this), this.getPagesSuggestions = this.getPagesSuggestions.bind(this), this.getSearchContent = this.getSearchContent.bind(this), this.resetSearch = this.resetSearch.bind(this), this.focusInputSearch = this.focusInputSearch.bind(this), this.preventLoadMore = this.preventLoadMore.bind(this), this.handleMobileNavOpener = this.handleMobileNavOpener.bind(this)
        }

        connectedCallback() {
            this.Search = this, this.isSearchDrawer = this.Search.hasAttribute("data-search-drawer"), this.initSearch()
        }

        initSearch() {
            this.searchForm = this.Search.querySelector("form"), this.searchInput = this.querySelector(".js-input-search"), this.searchInputReset = this.querySelector(".js-input-search-reset"), this.searchInputsClear = document.querySelectorAll(".js-input-search-clear"), this.searchContainerId = this.Search.dataset.searchContainerId, this.searchGridContainer = document.querySelector(`#${this.searchContainerId}`), this.searchContent = document.querySelector(".section-search__content"), this.searchClose = document.querySelector(".search-form__clear-button"), this.searchInputValue = this.searchInput.value, this.isSearchInit = !1, this.timeout = null, this.mobileBreakpoint = 1024, this.isMobile = window.matchMedia(`(max-width: ${this.mobileBreakpoint}px)`).matches;
            let e = new URLSearchParams(window.location.search).get("q");
            e && "" !== e && (this.getCollectionsSuggestions(), this.getArticlesSuggestions(), this.getPagesSuggestions()), this.closeSearchSuggestions(), this.bindEvents()
        }

        bindEvents() {
            if (this.searchInput && this.searchInput.addEventListener("keyup", this.userTyping), this.searchInputsClear) for (let e = 0; e < this.searchInputsClear.length; e++) this.searchInputsClear[e].addEventListener("click", this.resetSearch);
            this.searchInputReset && this.searchInputReset.addEventListener("click", this.resetSearch), this.searchInput && this.searchInput.addEventListener("click", this.focusInputSearch), this.isSearchDrawer && (this.searchDrawer = document.querySelector("w3-drawer-search.drawer-search"), this.searchDrawer.addEventListener("drawer--open", () => this.focusInputSearch()), this.focusInputSearch()), !this.isSearchDrawer && this.isMobile && this.searchClose.addEventListener("click", this.resetSearch)
        }

        closeSearchSuggestions() {
            if (this.isMobile) for (let e of (this.searchSuggestions = document.querySelectorAll(".js-search-suggestions"), this.searchSuggestions)) e.removeAttribute("open")
        }

        handleMobileNavOpener() {
            this.searchDrawer.isDrawerOpen || setTimeout(() => {
                this.searchDrawer.openDrawer()
            }, 420)
        }

        preventLoadMore() {
            this.searchLoadMore = this.searchGridContainer.querySelector("w3-load-more"), this.searchLoadMore && this.searchLoadMore.addEventListener("click", e => {
                e.preventDefault(e), this.searchForm.submit()
            })
        }

        focusInputSearch() {
            setTimeout(() => {
                this.searchInput.focus()
            }, 200), this.searchInput.focus()
        }

        resetSearch() {
            this.searchInput.value = "", this.searchInputValue = "", this.searchInput.blur(), this.isSearchInit = !1, new URL(location), window.history.replaceState(null, null, "?q="), this.getSearchContent(), this.focusInputSearch()
        }

        userTyping(e) {
            if ("Enter" !== e.key && 13 !== e.key) {
                let e = "";
                "search" == Shopify.templateName && new URLSearchParams(window.location.search).forEach(function (t, s) {
                    s.includes("filter.") && (e += `&${s}=${t}`)
                });
                let t = `?q=${this.searchInput.value}&type=product${e}`;
                this.isSearchDrawer || window.history.replaceState(null, null, t), this.searchInput.value.replace(/ /g, "") !== this.searchInputValue.replace(/ /g, "") && (this.timeout && clearTimeout(this.timeout), this.timeout = setTimeout(() => {
                    this.isSearchInit = !0, this.searchInputValue = this.searchInput.value, this.getSearchContent(t)
                }, 300))
            }
        }

        async getSearchContent(t) {
            await fetch(`${e}/search${t}&view=ajax`).then(e => e.text()).then(e => {
                let t = new DOMParser().parseFromString(e, "text/html").querySelector(`#${this.searchContainerId}`);
                this.searchGridContainer.innerHTML = t.innerHTML, this.isSearchDrawer && this.preventLoadMore(), "" != this.searchInput.value && (this.getCollectionsSuggestions(), this.getArticlesSuggestions(), this.getPagesSuggestions(), this.closeSearchSuggestions()), window.lozadObserver.observe()
            }).then(() => {
                let e = new CustomEvent("search:updated");
                window.dispatchEvent(e)
            }).catch(function (e) {
                console.error(e)
            })
        }

        async getCollectionsSuggestions() {
            await fetch(`${e}/search/suggest.json?q=${this.searchInput.value}&resources[type]=collection`).then(e => e.json()).then(e => {
                if (e.resources.results) {
                    let t = e.resources.results.collections;
                    this.appendSuggestions(t)
                }
            }).catch(function (e) {
                console.error(e)
            })
        }

        async getArticlesSuggestions() {
            await fetch(`${e}/search/suggest.json?q=${this.searchInput.value}&resources[type]=article`).then(e => e.json()).then(e => {
                if (e.resources.results) {
                    let t = e.resources.results.articles;
                    this.appendArticles(t)
                }
            }).catch(function (e) {
                console.error(e)
            })
        }

        async getPagesSuggestions() {
            await fetch(`${e}/search/suggest.json?q=${this.searchInput.value}&resources[type]=page`).then(e => e.json()).then(e => {
                if (e.resources.results) {
                    let t = e.resources.results.pages;
                    this.appendPages(t)
                }
            }).catch(function (e) {
                console.error(e)
            })
        }

        async getArticleMetafieldImage(id) {
            if (id) {
                return await requestStorefrontAPI({
                    query: `{
                        article(id:"gid://shopify/Article/${id}") {
                            title,
                            card_image_result : metafield(namespace:"custom",key:"card_image"){
                                value
                                reference {
                                ... on MediaImage {
                                  image {
                                    url
                                  }
                                }
                              }
                            }
                        }
                    }`
                }).then(response => response.data);
            } else {
                return null;
            }
        }

        appendSuggestions(e) {
            let t = this.searchGridContainer.querySelector(".js-search-collection-suggestions"),
                s = this.searchGridContainer.querySelector(".js-search-collection-suggestions-list"),
                i = this.searchGridContainer.querySelector(".js-search-collection-suggestions-count");
            t && (i.textContent = `(${e.length})`, 0 == e.length && (s.textContent = window.translations.search.no_results_simple));
            for (let t = 0; t < e.length; t++) {
                let i = e[t].title.split("|"), r = i.length > 1 ? i[1].trim() : e[t].title;
                e[t].title.includes(">") && e[t].title.includes("|") && (r = e[t].title.split(">")[0].trim() + " " + e[t].title.split("|")[1].trim()), s.innerHTML += `
                <li class="search-collection">
                    <a href="${e[t].url}">
                        <span>${r}</span>
                    </a>
                </li>
            `
            }
        }

        async appendArticles(t) {
            let s = [], i = [], r = this.searchGridContainer.querySelector(".js-search-article-suggestions-how-to"),
                n = this.searchGridContainer.querySelector(".js-search-article-suggestions-magazine"),
                a = this.searchGridContainer.querySelector(".js-search-article-suggestions-how-to-count"),
                h = this.searchGridContainer.querySelector(".js-search-article-suggestions-magazine-count"),
                c = this.searchGridContainer.querySelector(".js-search-article-suggestions-how-to-list"),
                o = this.searchGridContainer.querySelector(".js-search-article-suggestions-magazine-list");
            for (let r = 0; r < t.length; r++) {
                let image = null
                let metafieldImage = await this.getArticleMetafieldImage(t[r].id);
                if (metafieldImage?.article?.card_image_result?.reference?.image?.url) {
                    image = metafieldImage?.article?.card_image_result?.reference?.image?.url
                } else if (t[r].image) {
                    image = t[r].image;
                }

                let n = t[r].url;
                n.startsWith(`${e}/blogs/how-to`) ? s.push(t[r]) : n.startsWith(`${e}/blogs/magazine`) && i.push(t[r]);
                let a = `
                <li class="search-article u-full-width u-marg-b-xl">
                    <a href="${n}" class="u-flex u-gap-m">
                        ${image ? '<div class="search-article__image u-flex-shrink-0"><img class="u-object-fit-cover" src="' + image + '"/></div>' : ''}
                        <div class="u-flex u-flex-direction-column u-overflow-hidden">
                            <span class="body-1 u-ellipsis">${t[r].title.replace("|", " ")}</span>
                            ${t[r].summary_html && "" != t[r].summary_html ? '<p class="body-2 u-color-body-secondary">' + t[r].summary_html + "</p>" : ""}
                        </div>
                    </a>
                </li>
            `;
                s.includes(t[r]) ? c.innerHTML += a : i.includes(t[r]) && (o.innerHTML += a)
            }
            let l = s.length, u = i.length;
            r && (a.textContent = `(${l})`, 0 == l && (c.textContent = window.translations.search.no_results_simple)), n && (h.textContent = `(${u})`, 0 == u && (o.textContent = window.translations.search.no_results_simple))
        }

        appendPages(e) {
            let t = this.searchGridContainer.querySelector(".js-search-page-suggestions"),
                s = this.searchGridContainer.querySelector(".js-search-page-suggestions-list"),
                i = this.searchGridContainer.querySelector(".js-search-page-suggestions-count");
            t && (i.textContent = `(${e.length})`, 0 == e.length && (s.textContent = window.translations.search.no_results_simple));
            for (let t = 0; t < e.length; t++) s.innerHTML += `
            <li class="search-collection">
                <a href="${e[t].url}">
                    <span>${e[t].title}</span>
                </a>
            </li>
            `
        }
    }

    customElements.define("w3-search", t)
}();
